<template>
  <div>
    <div
      v-if="!user.isActive"
      class="user-popup--is-unactive"
    >
      <div class="user-popup--info">
        <div class="name">
          {{ $t('messages.hi') }}, {{ user.displayName }} !
        </div>
        <span>
          {{ $t('messages.please_confirm_email_after_regis') }}
        </span>
      </div>
      <div
        class="text"
        @click="$router.push({ name: 'SendConfirmationEmail' })"
      >
        {{ $t('messages.resend_an_email') }}
      </div>
    </div>
    <div
      v-if="user.isActive"
      :class="['user-popup--item', { 'top-item': user.isActive }]"
      data-test="user-popup--my-profile-menu"
      @click="$router.push({ name: 'UserProfile' })"
    >
      <div class="user-popup--item--left">
        <img src="/static/svg/icon-my-profile.svg">
      </div>
      <div class="user-popup--item--right">
        {{ $t('menu.profile') }}
      </div>
      <div class="user-popup--item--divider"/>
    </div>
    <div
      v-if="user.isActive"
      class="user-popup--item"
      data-test="user-popup--trade-history-menu"
      @click="$router.push({ name: 'TradeHistory' })"
    >
      <div class="user-popup--item--left">
        <img src="/static/svg/icon-trade-history.svg">
      </div>
      <div class="user-popup--item--right">
        {{ $t('menu.tradeHistory') }}
      </div>
      <div class="user-popup--item--divider"/>
    </div>
    <div
      v-if="user.isActive"
      class="user-popup--item"
      data-test="userPopup--kyc-menu"
      @click="clickOpenKycPage"
    >
      <div class="user-popup--item--left">
        <img src="/static/svg/icon-kyc.svg">
      </div>
      <div class="user-popup--item--right">
        {{ $t('menu.kyc') }}

      </div>
      <div class="user-popup--item--right--subtitle">
        <div
          :class="[
            'user-popup--item--kyc-status',
            {
              'verifying': user.kycStatus === 'VERIFYING',
              'request-change': user.kycStatus === 'REQUEST_CHANGE',
              'approved': user.kycStatus === 'APPROVED',
              'rejected': user.kycStatus === 'REJECTED'
            }
          ]"
        >
          {{ $t(`kyc.${user.kycStatus.toLowerCase()}`) }}
        </div>
      </div>
      <div class="user-popup--item--divider"/>
    </div>
    <div
      v-if="user.isActive"
      class="user-popup--item"
      data-test="user-popup--suit-test-menu"
      @click="$router.push({ name: 'SuitabilityTest' })"
    >
      <div class="user-popup--item--left">
        <img src="/static/svg/menu-icon-suitability-test.svg">
      </div>
      <div class="user-popup--item--right">
        {{ $t('menu.suit_test') }}
      </div>
      <div class="user-popup--item--divider"/>
    </div>
    <div
      v-if="user.isActive"
      class="user-popup--item"
      data-test="user-popup--knowledge-test-menu"
      @click="$router.push({ name: 'KnowledgeTest' })"
    >
      <div class="user-popup--item--left">
        <img src="/static/svg/menu-icon-knowledge-test.svg">
      </div>
      <div class="user-popup--item--right">
        {{ $t('menu.knowledge_test') }}
      </div>
      <div class="user-popup--item--divider"/>
    </div>
    <div
      v-if="user.isActive"
      class="user-popup--item"
      @click="$router.push({ name: 'ReferralProgram' })"
    >
      <div class="user-popup--item--left">
        <img src="/static/svg/icon-refferal.svg">
      </div>
      <div class="user-popup--item--right">
        {{ $t('menu.referral_program') }}
      </div>
      <div class="user-popup--item--divider"/>
    </div>
    <div
      v-if="user.isActive"
      :class="['user-popup--item', { 'top-item': user.isActive }]"
      @click="clickOpenKULTokenBalance()"
    >
      <div class="user-popup--item--left">
        <img src="/static/svg/icon-kulap-token.svg">
      </div>
      <div class="user-popup--item--right">
        {{ $t('menu.kulap_token') }}
      </div>
      <div class="user-popup--item--right--subtitle">
        {{ showTotalKULToken }} KUL
      </div>
      <div class="user-popup--item--divider"/>
    </div>
    <div
      class="user-popup--item"
      @click="$emit('logout')"
    >
      <div class="user-popup--item--left">
        <img src="/static/svg/icon-logout.svg">
      </div>
      <div class="user-popup--item--right">
        {{ $t('buttons.logout') }}
      </div>
    </div>
  </div>
</template>

<script>
import { calTotalKULToken } from '@/utils/helper'
export default {
  name: 'UserPopup',
  props: {
    user: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    showTotalKULToken () {
      return calTotalKULToken(this.user.rewards)
    }
  },
  methods: {
    clickOpenKycPage () {
      if (this.user.kycStatus === 'UNVERIFIED') {
        this.$router.push({ name: 'KYC' })
      } else {
        this.$router.push({ name: 'SummaryOfKYC' })
      }
    },
    clickOpenKULTokenBalance () {
      if (this.$router.currentRoute.name === 'UserProfile') {
        this.$scrollTo('#user-profile-token-balance')
      } else {
        this.$router.push({name: 'UserProfile', hash: '#user-profile-token-balance'})
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.user-popup {
  width: 235px;
  border-radius: 3px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
  background-color: #ffffff;
  position: absolute;
  left: -100px;
  z-index: 49;

  &--is-unactive {
    width: 100%;
    background-color: #fff;
    text-align: center;
    padding: 10px 22px;
    border-radius: 3px 3px 0 0;
    cursor: auto;

    .text {
      display: block;
      width: 100%;
      padding: 7px;
      background-color: #f15c25;
      color: #ffffff;
      border-radius: 20px;
      font-size: 14px;
      font-weight: 900;
      cursor: pointer;
    }
  }

  // &--is-unactive:hover {
  //   background-color: #f3f3f3;
  // }

  &--item {
    float: left;
    width: 100%;
    text-align: left;
    font-size: 15px;
    font-weight: bold;
    color: #4f4f4f;
    padding: 11px 25px 0 25px;

    &--left {
      float: left;
      width: 30px;
      margin-right: 15px;
    }

    &--right {
      float: left;
      width: calc(100% - 30px - 30px);
      &--subtitle {
        float: left;
        font-size: 14px;
        color: #b2b2b2;
      }
    }

    &--divider {
      float: left;
      width: 100%;
      height: 1px;
      background-color: #e0e0e0;
      margin-top: 11px;
    }

    &--text {
      font-size: 14px;
      font-weight: 400;
      color: #b2b2b2;
    }
    &--kyc-status {
      color: #f15c25;
      font-size: 11px;
      float: right;
      background-color: #fff;
      text-align: center;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      padding: 3px 10px;
      margin-top: 2px;
      max-width: 83px;
      border-radius: 25px;
      border: 1px solid #f15c25;
      &.verifying {
        color: #0559af;
        border-color: #0559af;
      }
      &.request-change {
        color: #dc3731;
        border-color: #dc3731;
      }
      &.approved {
        color: #43a047;
        border-color: #43a047;
      }
      &.rejected {
        color: #dc3731;
        border-color: #dc3731;
      }
    }
  }

  &--item:hover {
    color: #2193ff;
    cursor: pointer;
    background-color: #f3f3f3;
  }

  &--item:last-child {
    padding-bottom: 11px;
  }

  &--info {
    margin: 10px auto;
    color: #333;
    text-align: left;
    .name {
      font-weight: bold;
      margin-bottom: 10px;
    }
    span {
      overflow-wrap: break-word;
    }
  }

  &--info:hover {
    color: #333;
    // background-color: #f3f3f3;
  }
}
</style>



// WEBPACK FOOTER //
// src/features/Header/components/UserPopup.vue